
export const hamburger = () => {
    let tile = document.querySelector(".header__tile");
    document.querySelectorAll('.btn2').forEach(menuItem => {
        menuItem.addEventListener('click', () => {
            menuItem.classList.toggle('open');
            if (tile) {
                tile.classList.toggle("tile--active");
            }

        });
    });
}

